import OmsDrillDownPanel from '../../../../pages/Dashboard/manager/OmsDrillDownPanel';
import type { OmsDrillBucket } from '../types';

interface Props {
  bucket: OmsDrillBucket | null;
  onClose: () => void;
  onOpenProject: (projectId: string) => void;
}

/** Slide-in detail drawer for any KPI bucket (projects or resources). */
export default function DrillDownDrawer({ bucket, onClose, onOpenProject }: Props) {
  return <OmsDrillDownPanel bucket={bucket} onClose={onClose} onOpenProject={onOpenProject} />;
}
